// 地址搜尋與反向地理編碼（vms-web MAP-05）。品牌地圖 key 到位前：dev / test 經平台的開發用後備 /v1/geo/*（OSM Nominatim，
// 全平台每秒 1 次、有快取），只在按下搜尋時才問、不做逐字自動完成。有 key 之後改用供應商 JS SDK（MAP-04，跟 key 一起做）。
// 進出一律 WGS-84。
import { kinioFetch, planeBase } from '@kinio/web-sdk';
import { hasDevFeatures } from './appConfig';

export interface Place {
  display_name: string;
  lat: number;
  lng: number;
  /** ISO 3166-1 alpha-2 大寫 */
  country_code?: string;
}

/** 這個環境有沒有地址搜尋（現在只有 dev / test 的開發用後備）。 */
export function geocoderAvailable(env: string): boolean {
  return hasDevFeatures(env);
}

export const geocodeApi = {
  search: (api: string, q: string, lang: string) =>
    kinioFetch<{ data: Place[] }>(`${planeBase(api)}/v1/geo/search?q=${encodeURIComponent(q)}&lang=${encodeURIComponent(lang)}&limit=5`).then((r) => r?.data ?? []),
  reverse: (api: string, p: { lat: number; lng: number }, lang: string) =>
    kinioFetch<{ data: Place[] }>(`${planeBase(api)}/v1/geo/reverse?lat=${p.lat}&lng=${p.lng}&lang=${encodeURIComponent(lang)}`).then((r) => r?.data?.[0] ?? null),
};
